import { render, staticRenderFns } from "./ChattingInput.vue?vue&type=template&id=e5c252e4&"
import script from "./ChattingInput.vue?vue&type=script&lang=js&"
export * from "./ChattingInput.vue?vue&type=script&lang=js&"
import style0 from "./ChattingInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports